// src/data/committeeData.js
//
// Section 736 (ruling 321 slice 3c): the committee TABLE is installation content - installations\smart-td\content\committeeTables.js,
// projected to src\data\committeeTables.js. This is the code: it exports that table as COMMITTEE_LOOKUP (the same object, so
// every importer is unchanged) and derives RAILROADS from it.
import { COMMITTEE_LOOKUP_TABLE } from './committeeTables';

export const COMMITTEE_LOOKUP = COMMITTEE_LOOKUP_TABLE;

// RAILROADS IS DERIVED, NOT MAINTAINED (2026-09-22, section 366, audit finding A4).
//
// This was a hand-written list of the railroads every dropdown offers, sitting twenty lines above
// COMMITTEE_LOOKUP, which is the same fact. They had drifted: 'Duluth Missabe & Iron Range / CN' was in
// the committee table and in no dropdown, so **a DMIR yardmaster could not select his railroad on any
// screen and GO-DMIR could receive no claim, case or application.** Not degraded - absent.
//
// Deriving it means there is nothing left to keep in step. Add a railroad to the committee table (committeeTables.js) and
// every dropdown offers it; the two can no longer disagree, because there is only one of them.
// (Declared AFTER the lookup it reads, and exported the same way, so every existing import is unchanged.)

export const RAILROADS = Object.freeze(Object.fromEntries(
  Object.entries(COMMITTEE_LOOKUP).map(([craft, byRailroad]) => [craft, Object.freeze(Object.keys(byRailroad))])
));
